import { type TypeSelectOption } from '@thefarmersfront/kitchen';

import type { IRowNode } from 'ag-grid-community';

import { Table, TableBottomField, TableTopField } from '~/components/common';

import { getClaimRegisterOrdersColumnDefs } from '~/utils';

import { CLAIM_PAGE_SIZE } from '~/constants/claim';

import type { TypePagination } from '~/types/common.types';
import type { TypeOrders } from '~/types/order.types';

import styles from './ClaimRegisterFirstStepTable.module.scss';

const ClaimRegisterFirstStepTable = ({
  data,
  pagination,
  onChangePageLimit,
  onChangePage,
  onChangeRowSelection,
}: {
  data: TypeOrders[] | null;
  pagination: TypePagination;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onChangePage: (value: number) => void;
  onChangeRowSelection: (value: IRowNode[]) => void;
}) => {
  const { columnDefs, gridOptions } = getClaimRegisterOrdersColumnDefs();

  return (
    <div className={styles['table-container']}>
      <TableTopField dataTotalCount={pagination.totalCount} />
      <div className={styles['table-wrapper']}>
        <Table
          data={data}
          options={{ columnDefs, ...gridOptions }}
          rowStatusType={data === null ? 'INIT' : 'EMPTY'}
          onSelectionChange={onChangeRowSelection}
        />
      </div>
      <TableBottomField
        pageSizeOptions={Object.values(CLAIM_PAGE_SIZE)}
        currentPage={pagination.currentPage}
        totalCount={pagination.totalCount}
        pageSize={pagination.pageSize}
        onChangePageLimit={onChangePageLimit}
        onClickPage={onChangePage}
      />
    </div>
  );
};

export default ClaimRegisterFirstStepTable;
